import React, { useState } from "react";
import { Banner, Typography } from "@reconvert/react-ui-component";
import { Box, Button } from "@chakra-ui/react";
import { useAppSelector } from "../../app/hooks";
import { selectAppState } from "../../app/slice/appSlice";
import { PageNames } from "../../app/slice/appSlice.model";
import { useTranslation } from "react-i18next";
import { Slot } from "../../models";
import { IFramePostMessageType, sendPostMessage } from "../../utils/helpers";
import SlotSetupModal from "./SlotSetupModal";
import ChakraSlotSetupModal from "./ChakraSlotSetupModal";
import { PageType, PreMadeTemplateType } from "@reconvert/reconvert-utils";
// import { BOTTOM_SHEET_TYPES, openBottomSheet } from "../../app/slice/mobileSlice";

const bannerType = "warning";

const SlotWarningBanner = ({ slot }: { slot: Slot }) => {
  const { t } = useTranslation();
  const { activePage, isEnableAppBridgeModal } = useAppSelector(selectAppState);
  const [isQuickSetupModalOpen, setIsQuickSetupModalOpen] = useState(false);
  const isAppEmbedSlot =
    slot.type === PreMadeTemplateType.QUANTITY_DISCOUNT ||
    activePage === PageType.PRE_PURCHASE_CART_DRAWER_PAGE;
  // const dispatch = useAppDispatch();

  const handleQuickSetupModalOpen = () => {

    // if (isMobile) {
    //   dispatch(openBottomSheet({ type: BOTTOM_SHEET_TYPES.QUICK_SETUP, props: { slot } }));
    //   return;
    // }

    if (isEnableAppBridgeModal) {
      sendPostMessage(IFramePostMessageType.OPEN_QUICK_SLOT_SETUP_MODAL, {
        slot: slot,
      });
    } else {
      setIsQuickSetupModalOpen(true);
    }
  };

  return (
    <Box mx={"16px"} mt={3} p={2}>
      <Banner
        title={
          isAppEmbedSlot
            ? t("Upsell.com is turned off in your theme")
            : t("Your slot is not added to the {{pageName}}", { pageName: t(PageNames[activePage!]!) })
        }
        status={bannerType as any}
        hasBackground
        description=""
        body={
          <Typography variant="body">
            {isAppEmbedSlot
              ? t("Turn it on so your customers can see this offer. Enable in theme editor")
              : t("Please add the slot to your {{pageName}} to ensure your customers see it. Click the button below to be guided through the process step-by-step.", { pageName: t(PageNames[activePage!]!) })}
          </Typography>
        }
        footer={
          <Button color="link.color" variant={"unstyled"} onClick={handleQuickSetupModalOpen} size="sm">
            {t("Quick setup")}
          </Button>
        }
      />
      {isEnableAppBridgeModal ? (
        <SlotSetupModal isOpen={isQuickSetupModalOpen} slot={slot} onClose={() => setIsQuickSetupModalOpen(false)} />
      ) : (
        <ChakraSlotSetupModal
          isOpen={isQuickSetupModalOpen}
          slot={slot}
          onClose={() => setIsQuickSetupModalOpen(false)}
        />
      )}
    </Box>
  );
};

export default SlotWarningBanner;
